/* 30.09.: Skateboard-Logo rollt ab und zu am unteren Bildschirmrand entlang, von rechts oben leicht schräg nach links unten (Blickrichtung der Figur).
   - erstes Mal ca. 30 s nach Ankunft, danach alle 4–6 min, höchstens 3x pro Besuch (zählt über Seitenwechsel)
   - nie bei „Bewegung reduzieren“, nie in Hintergrund-Tabs, blockiert keine Klicks
   - Test: ?skate an die Adresse hängen, dann rollt es nach 1,5 s (und danach immer wieder)
   - Die Zeichnung liegt in 7 Teilen (svm-skate-1.txt … -7.txt) und wird erst beim ersten Rollen geladen
   - 30.09. abends: Farbe Schwarz statt Grün (per CSS, die Zeichnung selbst bleibt unverändert) */
(function () {
  var script = document.currentScript;
  var parts = ((script && script.getAttribute('data-parts')) || '').split(' ').filter(Boolean);
  if (!parts.length || !window.matchMedia || !window.Promise || !Element.prototype.animate) return;

  var KEY = 'svmSkate', MAX = 3, FIRST = 30000, GAP_MIN = 240000, GAP_MAX = 360000;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var test = /[?&]skate(=|&|$)/.test(location.search);
  var svgText = null, timer = null, current = null;

  function read() { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  var css = document.createElement('style');
  css.textContent =
    '.svm-skate{position:fixed;left:0;bottom:14px;width:130px;z-index:900;pointer-events:none;will-change:transform}' +
    '.svm-skate svg{display:block;width:100%;height:auto;overflow:visible;fill:#000}' +
    '.svm-skate__hub{transform-box:fill-box;transform-origin:50% 50%}' +
    '@media (max-width:749px){.svm-skate{width:90px;bottom:12px}}';
  document.head.appendChild(css);

  var st = read();
  if (!st.next) { st = { n: 0, next: Date.now() + FIRST }; write(st); }

  function schedule(wait) {
    clearTimeout(timer);
    if (test) { timer = setTimeout(go, wait || 1500); return; }
    st = read();
    if ((st.n || 0) >= MAX) return;
    timer = setTimeout(go, Math.max(4000, (st.next || 0) - Date.now()));
  }

  function go() {
    if (current || document.hidden || still.matches) return;
    if (document.documentElement.classList.contains('svm-noscroll')) { schedule(20000); return; }
    if (svgText) return roll();
    Promise.all(parts.map(function (u) {
      return fetch(u).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
    })).then(function (list) {
      var t = list.join('');
      if (t.indexOf('<svg') !== 0) return;
      svgText = t;
      roll();
    }).catch(function () {});
  }

  function roll() {
    if (!test) {
      st = read();
      st.n = (st.n || 0) + 1;
      st.next = Date.now() + GAP_MIN + Math.random() * (GAP_MAX - GAP_MIN);
      write(st);
    }
    var el = document.createElement('div');
    el.className = 'svm-skate';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = svgText;
    document.body.appendChild(el);
    current = el;

    var w = el.offsetWidth;
    var vw = document.documentElement.clientWidth;
    var dist = vw + 2 * w;
    // gemütlich: ca. 150 px pro Sekunde, 6–12 s pro Fahrt
    var dur = Math.min(12000, Math.max(6000, dist / 150 * 1000));
    var ease = 'cubic-bezier(.3,.2,.6,.9)';
    // leichtes Gefälle: oben rechts rein, unten links raus – höchstens ca. 7°
    var drop = Math.round(Math.min(window.innerHeight * 0.2, dist * 0.12));
    var tilt = -Math.atan2(drop, dist) * 180 / Math.PI;
    // Räder: Drehung passend zur Strecke, gegen den Uhrzeigersinn (Raddurchmesser ≈ 10 % der Logobreite)
    var deg = dist / (Math.PI * w * 0.1) * 360;

    var anims = [el.animate(
      [{ transform: 'translate3d(' + vw + 'px,' + (-drop) + 'px,0) rotate(' + tilt + 'deg)' },
       { transform: 'translate3d(' + (-w) + 'px,0,0) rotate(' + tilt + 'deg)' }],
      { duration: dur, easing: ease, fill: 'forwards' }
    )];
    el.querySelectorAll('.svm-skate__hub').forEach(function (hub) {
      anims.push(hub.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(' + (-deg) + 'deg)' }], { duration: dur, easing: ease }));
    });
    var svg = el.querySelector('svg');
    if (svg) anims.push(svg.animate(
      [{ transform: 'translateY(0)' }, { transform: 'translateY(-1px)' }, { transform: 'translateY(0)' }],
      { duration: 380, iterations: Math.ceil(dur / 380) }
    ));

    anims[0].onfinish = done;
    function done() {
      anims.forEach(function (a) { a.cancel(); });
      if (el.parentNode) el.parentNode.removeChild(el);
      current = null;
      schedule(test ? 3000 : 0);
    }
    el._stop = done;
  }

  function stop() { if (current && current._stop) { clearTimeout(timer); var c = current; c._stop(); } }
  if (still.addEventListener) still.addEventListener('change', function () { if (still.matches) { stop(); clearTimeout(timer); } else schedule(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else if (!current) schedule(); });

  if (!still.matches) schedule();
})();
